module.exports = __webpack_public_path__ + "images/hooray.164afb0d18ffc4d7055b.png";